<template lang="pug">
v-dialog(
    v-model="show",
    width="auto",
    scrollable,
    max-width="500px",
    persistent,
    v-if="item"
)
    form(
        @submit.prevent="validate()",
        data-vv-name="config",
        style="width: 100%"
    )
        v-card(style="border-radius: 10px;")
            v-card-title
                span.title Desativar
            v-card-text
                v-layout(row, wrap)
                    v-flex.xs12
                    v-radio-group(v-model="config.tipo_desativacao")
                        v-radio(label="Tempo Indefinido", :value="1", color="primary")
                        v-radio(label="Definir quantidade de dias", :value="2", color="primary")
                v-layout.areaInput(row, wrap, v-if="config.tipo_desativacao == TEMPO_DEFINIDO")
                  v-flex(md12 xs12)
                      v-menu(:close-on-content-click="false" transition="scale-transition" offset-y, min-width="10px")
                          template(v-slot:activator="{ on, attrs }")
                              v-text-field(v-model="config.data_indisponivel_formated" outline, label="Indique a data até a qual o item estará indisponível." readonly v-bind="attrs" v-on="on")
                          v-date-picker(v-model="config.data_indisponivel" no-title scrollable show-current)

                v-flex.md12.xs12.pt-0(v-bind:class="[$root.mobile ? 'areaAbtnsComplementos' : '']")
                        v-card-actions.right(v-if="($root.user.permissao_cardapio)")
                            v-spacer(v-if="!$root.mobile")
                            v-btn.btnSalvar(
                                depressed
                                type="submit",
                                color="primary",
                                :loading="loading",
                                :disabled="loading"
                                ) Confirmar
                        v-btn.right(
                            type="button",
                            flat,
                            color="gray darken-1",
                            @click.native="show = false; item=null;"
                        ) Fechar
    </template>

<script>
export default {
    $_veeValidate: {
        validator: "new",
    },
    data: () => ({
        show: false,
        loading: false,
        item: null,
        dias: null,
        TEMPO_INDEFINIDO: 1,
        TEMPO_DEFINIDO: 2,
        config: null
    }),
    mounted() {

    },
    watch: {
        config: {
            deep: true,
            handler(config) {
                console.log('watch config')
                if (config.tipo_desativacao == this.TEMPO_DEFINIDO) {
                  if (config.data_indisponivel) {
                    this.item.data_disponivel = this.$dayjs(config.data_indisponivel).format("YYYY-MM-DD 00:00:00");
                    this.config.data_indisponivel_formated = this.$dayjs(config.data_indisponivel).format("DD/MM/YYYY");
                  }
                }
            }
        }
    },
    methods: {
        open(item) {
            this.show = true;
            this.item = item;
            this.config = {
                tipo_desativacao: this.TEMPO_INDEFINIDO,
                data_indisponivel: this.$dayjs().add(1, 'day').format("YYYY-MM-DD"),
                data_indisponivel_formated: this.$dayjs().add(1, 'day').format("DD/MM/YYYY")
            };
        },
        async validate() {
            try {
                this.loading = true;

                if (this.config.tipo_desativacao == 2 && this.item.data_disponivel && this.$dayjs(this.item.data_disponivel).isSameOrBefore(this.$dayjs(), 'day')) {
                    throw "Por gentileza, selecione uma data e hora no futuro.";
                }

                this.save(this.item);
                this.loading = false;
                this.show = false;
            } catch (error) {
                window.getApp.$emit("APP_ALERT", { color: "red", text: error });
                this.loading = false;
            }
        },
        async save(item) {
            try {

                if (this.config.tipo_desativacao == this.TEMPO_INDEFINIDO) {
                    item.ativo = 0;
                } else if (this.config.tipo_desativacao == this.TEMPO_DEFINIDO) {
                    item.ativo = 1;
                    item.disponivel = 0;
                }

                item.data_disponivel = this.$dayjs(this.config.data_indisponivel).format("YYYY-MM-DD 00:00:00");
                const response = await this.$axios.put("/catalogo/item", item);

                this.$emit('refresh-itens', item);

                this.loading = false;

                window.getApp.$emit("APP_ALERT", {
                    color: "success",
                    text: !item.disponivel && item.ativo ?
                        `Item desativado até ${this.$dayjs(item.data_disponivel).format('DD/MM/YYYY')}.` :
                        `Item desativado por tempo indefinido.`,
                });

            } catch (error) {
                console.log(error)
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro desativar o item. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
                this.loading = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.areaAbtnsComplementos{
    padding: 0 !important;
    justify-content: flex-start;
    display: flex;
    flex-flow:column wrap;
    align-content: stretch;
    align-items: stretch;
}
.btnSalvar{
    width: 100%;
    border-radius: 5px !important;
    color:#fff;
    font-weight: 600;
}
</style>

<style lang="scss">
.areaInput .v-menu__content--fixed{
    min-width: 50px!important;
    box-shadow: none!important;
}
</style>
